import { render } from "./ForgotPasswordWrapper.vue?vue&type=template&id=09510864"
import script from "./ForgotPasswordWrapper.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__